import React from 'react';
import { RefreshCw, ShieldAlert, Home, AlertTriangle } from 'lucide-react';

export const ErrorPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center p-6 bg-background text-center overflow-hidden relative">
      {/* ── Background decoration ── */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-destructive/5 blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-primary/5 blur-3xl" />
      </div>

      <div className="relative flex flex-col items-center max-w-lg w-full animate-in zoom-in-95 fade-in duration-500">
        {/* ── Icon block ── */}
        <div className="relative mb-8">
          <div className="w-28 h-28 rounded-3xl bg-destructive/10 border border-destructive/20 flex items-center justify-center shadow-xl shadow-destructive/10">
            <AlertTriangle className="w-14 h-14 text-destructive" strokeWidth={1.5} />
          </div>
          {/* Orbiting dots */}
          <span className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-destructive/30 border-2 border-background" />
          <span className="absolute -bottom-2 -left-2 w-3.5 h-3.5 rounded-full bg-amber-400/40 border-2 border-background" />
        </div>

        {/* ── Badge ── */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-destructive/10 text-destructive font-bold text-xs mb-6 border border-destructive/20 uppercase  ">
          <ShieldAlert size={13} />
          System Error
        </div>

        {/* ── Heading ── */}
        <h1 className="text-3xl md:text-4xl font-black text-foreground mb-3 tracking-tight leading-tight">
          Oops! Something
          <br />
          <span className="text-destructive">went wrong</span>
        </h1>

        <p className="text-sm md:text-base text-muted-foreground max-w-sm mb-10 leading-relaxed">
          Our engineers are working on fixing this. In the meantime, try refreshing the page or head
          back home.
        </p>

        {/* ── Actions ── */}
        <div className="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
          <button
            onClick={() => window.location.reload()}
            className="flex items-center justify-center gap-2 w-full sm:w-auto px-7 py-3 rounded-xl bg-destructive text-white font-bold hover:bg-destructive/90 shadow-lg shadow-destructive/25 transition-all active:scale-[0.97] text-sm"
          >
            <RefreshCw size={16} />
            Refresh System
          </button>
          <button
            onClick={() => (window.location.href = '/')}
            className="flex items-center justify-center gap-2 w-full sm:w-auto px-7 py-3 rounded-xl bg-card border border-border text-foreground font-bold hover:bg-accent transition-all active:scale-[0.97] text-sm"
          >
            <Home size={16} />
            Back to Home
          </button>
        </div>

        {/* ── Error code ── */}
        <p className="mt-10 text-[11px] text-muted-foreground/50 font-mono   uppercase">
          Error Code: 500 · Internal Server Error
        </p>
      </div>
    </div>
  );
};
